import { getEnv } from "@umami/utils";

export const getEnvironmentVariable = (name: string) => getEnv(`VITE_${name}`);
